import { createSlice } from "@reduxjs/toolkit";
import { NotificationProtocol, ServerError } from "@/lib/types";
import {
  getNotifications,
  getUnreadNotificationsCount,
  readNotifications,
} from "@/store/actions/notification-actions";
import { notificationKey } from "@/helpers/notificationKey";

import { NotificationState } from "@/store/types";

const initialState: NotificationState = {
  loader: {
    messages: false,
  },
  error: "",
  newMessages: 0,
  messages: [],
  freshKeys: [],
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    onNotificationReceived: (state, action: { payload: NotificationProtocol }) => {
      // Newest first, like the fetched list.
      state.messages = [action.payload, ...state.messages];
      state.newMessages = state.newMessages + 1;
    },
  },
  extraReducers: (builder) => {
    builder
      // ============= get  =============
      .addCase(getNotifications.pending, (state) => {
        state.loader.messages = true;
        state.error = "";
      })
      .addCase(getNotifications.fulfilled, (state, { payload }) => {
        state.loader.messages = false;
        state.messages = payload.map(ntfn => ({
          id: ntfn.id,
          head: {
            type: ntfn.type,
          },
          body: {
            name: ntfn.name,
            description: ntfn.description,
            code: ntfn.code,
            ...ntfn.params,
            isRead: ntfn.isRead,
          },
          tail: {
            created: ntfn.created,
            updated: ntfn.updated,
          }
        }));
        state.freshKeys = state.messages
          .filter((message) => !message.body.isRead)
          .map(notificationKey);
        state.newMessages = state.freshKeys.length;
      })
      .addCase(getNotifications.rejected, (state, action: any & { payload: ServerError }) => {
        state.loader.messages = false;
        state.error = action.payload?.message ?? "";
      })
      // ============= read  =============
      .addCase(readNotifications.fulfilled, (state) => {
        // Server marked everything read: clear the badge now instead of on the
        // next fetch. `freshKeys` keeps this opening's items under "new".
        state.newMessages = 0;
        state.messages.forEach((message) => {
          message.body.isRead = true;
        });
      })
      // ============= unread count  =============
      .addCase(getUnreadNotificationsCount.fulfilled, (state, { payload }) => {
        state.newMessages = payload;
      })
  }
});

export const actions = notificationSlice.actions;
export default notificationSlice.reducer;
